import { inject, computed } from "vue";
import type { EnhancedLabPermissions } from "../types/lab";

export const usePermissions = () => {
  const permissions = inject<EnhancedLabPermissions>("labPermissions");

  const canView = computed(() => permissions?.isAllowed("cadastroexamesV"));
  const canCreate = computed(() => permissions?.isAllowed("cadastroexamesI"));
  const canEdit = computed(() => permissions?.isAllowed("cadastroexamesA"));
  const canDelete = computed(() => permissions?.isAllowed("cadastroexamesX"));

  return {
    canView,
    canCreate,
    canEdit,
    canDelete,
  };
};
